<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="title"
    width="70%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <div class="chapter">
        <el-scrollbar class="list">
          <div
            v-for="chapter in chapterList"
            :key="chapter.id"
            class="item"
          >
            <div class="name">
              {{ chapter.chapterName }}
            </div>
            <div class="son-list">
              <div
                v-for="son in chapter.sonList"
                :key="son.id"
                class="son"
                :class="{'active': chapterIds.includes(son.id)}"
              >
                {{ son.chapterName }}
                <span>
                  <i class="el-icon-check" />
                </span>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
      <div class="table">
        <el-table
          :data="dateList"
          border
        >
          <el-table-column
            prop="amContent"
            label="上午"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.amContent.classContent">{{ scope.row.amContent.classContent }}</span>
              <span v-if=" scope.row.amContent.classContent === ''">
                <i
                  class="el-icon-plus cursor"
                  @click="openItemDialog('amContent',scope)"
                />
              </span>
              <span v-else>
                <i
                  class="el-icon-edit-outline cursor"
                  @click="openItemDialog('amContent',scope)"
                />
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="pmContent"
            label="下午"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <div class="item">
                <span v-if="scope.row.pmContent.classContent">{{ scope.row.pmContent.classContent }}</span>
                <span v-if="scope.row.pmContent.classContent === ''">
                  <i
                    class="el-icon-plus cursor"
                    @click="openItemDialog('pmContent',scope)"
                  />
                </span>
                <span v-else>
                  <i
                    class="el-icon-edit-outline cursor"
                    @click="openItemDialog('pmContent',scope)"
                  />
                </span>
                <!-- <span
                  class="delete"
                  @click="deletedItem(scope.$index)"
                >
                  移出
                </span> -->
                <el-dropdown
                  trigger="click"
                  @click.native.stop="openDropDown(scope.$index)"
                >
                  <span class="el-dropdown-link">
                    <svg-icon
                      name="more"
                    />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="deletedItem()">
                      删除
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="moveChapter(1)">
                      上移
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="moveChapter(-1)">
                      下移
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-button
          type="primary"
          class="add-column"
          icon="el-icon-plus"
          @click="addColumn"
        >
          新增一列
        </el-button>
      </div>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';

export default {
  name: 'ScheduleTplDialog',
  components: { customeDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    data: {
      type: [Array],
    },
    courseId: {
      type: Number,
    },
    getChapterItem: {
      type: [Object],
    },
    chapterList: {
      type: Array,
      default: () => [],
    },
    chapterIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      title: '课程表模板维护',
      cancelText: '取消',
      dateList: [],
      activeItem: {},
    };
  },

  watch: {
    getChapterItem(data) {
      this.dateList[this.activeItem.index][this.activeItem.type] = { ...data };
    },
    data(list) {
      this.dateList = this._.cloneDeep(list);
    },
  },
  methods: {
    // 删除一行
    deletedItem() {
      this.$emit('deletedItem', this.activeIndex);
    },
    // 新增一行
    addColumn() {
      this.$emit('addColumn');
    },
    moveChapter(num) {
      this.$emit('moveColumn', this.activeIndex, num);
    },
    // 打开下拉弹窗
    openDropDown(index) {
      this.activeIndex = index;
    },
    // 打开弹窗编辑章节
    openItemDialog(type, scope) {
      console.log(scope);
      this.activeItem = {
        type,
        index: scope.$index,
      };
      this.$emit('openItemDialog', scope.row[type]);
      this.$emit('activeItem', this.activeItem);
    },
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
    },
    async confirm() {
      const dateList = this._.cloneDeep(this.dateList);
      dateList.forEach((date) => {
        date.amContent.chapterList = date.amContent.chapterList.map((v) => ({ courseChapterId: v.id }));
        date.pmContent.chapterList = date.pmContent.chapterList.map((v) => ({ courseChapterId: v.id }));
      });
      const data = await axClient.course.desertScheduleContent({
        courseId: this.courseId,
        dateList,
      });
      if (!data) return;
      this.$message.success('修改课程表模板成功');
      this.$emit('update:dialogVisible', false);
      this.$emit('confirm');
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  display: flex;
  justify-content: space-between;
  min-height: 200px;
  & > div {
    border: 1px solid rgba($--base-color-grey, $alpha: 0.3);
    box-sizing: border-box;
    border-radius: 3px;
  }
  .chapter {
    padding: 10px;
    flex: 1;
    margin-right: 16px;
    .title {
      font-size: 16px;
      margin-bottom: 10px;
    }
    .list {
      color: $--base-color-black;
      height: 480px;
      font-size: 16px;
      line-height: 1;
      .name {
        font-weight: 500;
        margin-bottom: 12px;
      }
      .son {
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 5px 12px;
        &:last-child {
          margin-bottom: 12px;
        }
        i {
          display: none;
        }
        &.active {
          color: $--base-color-main;
          border: 1px solid $--base-color-main;
          border-radius: 3px;
          i {
            display: inline-block;
          }
        }
      }
    }
  }
  .table {
    flex: 2;
    border: none;
    .header {
      width: 80%;
      margin-left: 8%;
    }
    ::v-deep .el-table__row {
      .cell{
        justify-content: center;
        i{
          margin-left: 15px;
        }
      }
    }
    .item {
      padding-right: 50px;
      .el-dropdown{
        position: absolute;
        top: 0;
        bottom: 0;
        right: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .el-dropdown-link{
          svg{
            height: 16px;
          }
        }
      }
    }
  }
  .add-column {
    width: 30%;
    margin: auto;
    display: block;
    margin-top: 20px;
  }
}
</style>
